export const FEATURE_FLAGS = {
  LEGACY_PAGE_MIGRATION: 'legacy-page-migration',
};
